import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const AppointmentLocationsPage = lazy(() => import('@/containers/Views/AppointmentLocations/AppointmentLocationsPage'));

const AppointmentLocationsRouter = (
  <Route path="appointment_locations">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.AppointmentLocations} 
          permissions={EBasicActions.Find}
        >
          <AppointmentLocationsPage />
        </PrivateRoute>
      )} 
    />
  </Route>
);

export default AppointmentLocationsRouter;
